import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import {
  CreateOrUpdateJobCommentRequest,
  HttpResponse,
  JobComment,
} from "@/types";

export function useCreateJobComment() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({
      createJobCommentRequest,
    }: {
      createJobCommentRequest: CreateOrUpdateJobCommentRequest;
    }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/job-comments`;
      const res = await guacHttpClient.post<
        JobComment,
        HttpResponse<JobComment>,
        CreateOrUpdateJobCommentRequest
      >(path, createJobCommentRequest);

      return res.data;
    },
  });

  return mutation;
}
